import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: 'tyt-vertical-carousel-item',
    template: '<ng-content></ng-content>',
    styles: []
})
export class VerticalCarouselItemComponent {
    @HostBinding('class.active') active : boolean;
    @HostBinding('class.next') next : boolean;
    @HostBinding('class.previous') previous : boolean;
    @HostBinding('class.hold') hold : boolean;
    @Input() duration : number;
}